export const PageNotFound = () => {
    return (
        <div>
            <h1 className="text-3xl text-slate-100 font-bold">Page Not Found</h1>
        </div>
    )
}